import { Database, IDatabaseDescription, IEntity, ITable } from '../db/indexed';

export interface IKeyValueItem<T = any> extends IEntity {
	key: string;
	value: T;
}

export class KeyValueDatabase extends Database {
	readonly keyValues: ITable<IKeyValueItem>;

	getDescription(): IDatabaseDescription {
		return {
			databaseName: 'key-value-store',
			versions: {
				1: {
					schema: {
						keyValues: '&key',
					},
				},
			},
		};
	}
}
